// ----------------------------------------------------------------------
// <copyright file="Izenda.MainWrapper.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Main Wrapper component
 */

!(function () {

  var React = require('react');
  var classnames = require('classnames');
  var connect = require('share/enhancers/Izenda.Connect');
  var UiState = require('logic/Izenda.UiState');
  var BrowserUtils = require('share/utils/Izenda.BrowserUtils');
  var SettingsStore = require('logic/Izenda.SettingsStore');

  var MainWrapper = React.createClass({
    componentDidMount: function() {
      window.addEventListener('resize', this.handleWindowResize, false);
    },

    componentWillUnmount: function() {
      window.removeEventListener('resize', this.handleWindowResize, false);
    },

    handleWindowResize: function () {
      var isMobileDevice = BrowserUtils.isMobileDevice();
      if (isMobileDevice !== UiState.isMobile) {
        UiState.setMobileVersion(isMobileDevice);
      }
    },

    render: function () {
      var props = this.props;
      var showTenants = props.settingStore.settingLevel.showTenants();

      var wrapperClass = classnames(props.className, {
        'izenda-Main-wrapper-system-mode': UiState.hideSystemLevel,
        'izenda-Main-wrapper': !UiState.hideSystemLevel,
        'Izenda-main-wrapper-margin-top': !showTenants,
        'Izenda-main-wrapper-tenant-margin-top': showTenants
      });

      return (
        <section className={wrapperClass}>
          {props.children}

          <section className="izenda-Overlay" aria-expanded="false" />
        </section>
      );
    }
  });

  module.exports = connect()(MainWrapper);
})()



// WEBPACK FOOTER //
// ./ui/share/components/layout/Izenda.MainWrapper.jsx